import ApiService from '@/services/core/api.service'

const DashboardService = {
  async get () {
    return ApiService.get('user/total-booked-per-user')
  }
}

export default DashboardService
